/* eslint-disable react/prop-types */
import React from "react";
import DatePicker from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import { Box, Typography } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SwitchBox from "components/SwitchBox";
import SoftTypography from "components/SoftTypography";

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const ModalContent = ({ list, pickAll, setPickAll, handleChangeSwitch }) => {
  const [taxPeriod, setTaxPeriod] = React.useState("month"); // | time
  const [taxType, setTaxType] = React.useState("firstTime"); // | additional

  return (
    <>
      <Box
        sx={{
          p: 1,
          border: "1px solid black",
          borderRadius: 1,
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Chọn kỳ tính thuế
        </Typography>
        <SoftBox display="flex" flexDirection="column" my={1}>
          <SoftTypography component="label" variant="caption" fontWeight="bold" mb={0.5}>
            Kiểu kỳ
          </SoftTypography>
          <select style={selectStyle} onChange={(e) => setTaxPeriod(e.target.value)}>
            {/* <option value="quarterly">Từ quý - Đến quý</option> */}
            <option value="month">Từ tháng - Đến tháng</option>
            {/* <option value="month-quarterly">Từ tháng - Đến quý</option> */}
            {/* <option value="quarterly-month">Từ quý - Đến tháng</option> */}
          </select>
        </SoftBox>

        {taxPeriod === "quarterly" && (
          <>
            <Box display="flex" gap={1}>
              <Box>
                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Từ quý
                  </SoftTypography>
                </SoftBox>
                <SoftInput name="year" type="number" />
              </Box>
              <Box>
                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Năm
                  </SoftTypography>
                </SoftBox>
                <SoftInput name="year" type="number" />
              </Box>
            </Box>
            <Box display="flex" gap={1}>
              <Box>
                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Đến quý
                  </SoftTypography>
                </SoftBox>
                <SoftInput name="year" type="number" />
              </Box>
              <Box>
                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Năm
                  </SoftTypography>
                </SoftBox>
                <SoftInput name="year" type="number" />
              </Box>
            </Box>
          </>
        )}
        {taxPeriod === "month" && (
          <Box>
            <Box sx={{ width: "100%" }}>
              <SoftBox sx={{ width: "100%" }} mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Từ tháng
                </SoftTypography>
              </SoftBox>
              <DatePicker
                options={{
                  locale: Vietnamese,
                  plugins: [
                    new monthSelectPlugin({
                      shorthand: true,
                      dateFormat: "m-Y",
                      theme: "light",
                    }),
                  ],
                }}
                render={({ defaultValue }, ref) => (
                  <SoftInput defaultValue={defaultValue} inputRef={ref} />
                )}
              />
            </Box>
            <Box sx={{ width: "100%" }}>
              <SoftBox sx={{ width: "100%" }} mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Đến tháng
                </SoftTypography>
              </SoftBox>
              <DatePicker
                options={{
                  locale: Vietnamese,
                  plugins: [
                    new monthSelectPlugin({
                      shorthand: true,
                      dateFormat: "m-Y",
                      theme: "light",
                    }),
                  ],
                }}
                render={({ defaultValue }, ref) => (
                  <SoftInput defaultValue={defaultValue} inputRef={ref} />
                )}
              />
            </Box>
          </Box>
        )}
        {taxPeriod === "month-quarterly" && (
          <Box>
            <Box sx={{ width: "100%" }}>
              <SoftBox sx={{ width: "100%" }} mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Từ tháng
                </SoftTypography>
              </SoftBox>
              <DatePicker
                options={{
                  locale: Vietnamese,
                  plugins: [
                    new monthSelectPlugin({
                      shorthand: true,
                      dateFormat: "m-Y",
                      theme: "light",
                    }),
                  ],
                }}
                render={({ defaultValue }, ref) => (
                  <SoftInput defaultValue={defaultValue} inputRef={ref} />
                )}
              />
            </Box>

            <Box display="flex" gap={1}>
              <Box>
                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Đến quý
                  </SoftTypography>
                </SoftBox>
                <SoftInput name="year" type="number" />
              </Box>
              <Box>
                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Năm
                  </SoftTypography>
                </SoftBox>
                <SoftInput name="year" type="number" />
              </Box>
            </Box>
          </Box>
        )}
        {taxPeriod === "quarterly-month" && (
          <Box>
            <Box display="flex" gap={1}>
              <Box>
                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Từ quý
                  </SoftTypography>
                </SoftBox>
                <SoftInput name="year" type="number" />
              </Box>
              <Box>
                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Năm
                  </SoftTypography>
                </SoftBox>
                <SoftInput name="year" type="number" />
              </Box>
            </Box>
            <Box sx={{ width: "100%" }}>
              <SoftBox sx={{ width: "100%" }} mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Đến tháng
                </SoftTypography>
              </SoftBox>
              <DatePicker
                options={{
                  locale: Vietnamese,
                  plugins: [
                    new monthSelectPlugin({
                      shorthand: true,
                      dateFormat: "m-Y",
                      theme: "light",
                    }),
                  ],
                }}
                render={({ defaultValue }, ref) => (
                  <SoftInput defaultValue={defaultValue} inputRef={ref} />
                )}
              />
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default ModalContent;
